<!--
	A generic info/warning/success/error message for the user.
-->
<template>
	<div>
		<Message :toast="toast" :portal="getPortalId()">
			<slot>
				<!-- The v-html on the next line must go away. See Notification.ts for details. -->
				<!-- eslint-disable-next-line vue/no-v-html -->
				<span v-html="escape(from.Message)" />
			</slot>
		</Message>
		<Button :toast="toast" :portal="getPortalId('Close')">
			<span v-tr="'SessionMessageClose'" />
		</Button>
	</div>
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import type { SnotifyToast, SnotifyToastConfig } from "vue3-snotify";
import { MiaPlaza } from "../../../Reinforced.Typings";
import Button from "./Shared/Button.vue";
import Message from "./Shared/Message.vue";
import { type ForNotification } from "./Shared/DerivedInterfaces";
import { SNotification } from "./Shared/SNotification";

@Component({
	components: { Button, Message },
})
export class SessionMessage extends SNotification<ForNotification<MiaPlaza.Control.Vue.Notifications.ISessionMessage>> {
	protected getToastConstructor(): (config: SnotifyToastConfig) => SnotifyToast {
		return (config) => {
			if (this.from.Type === MiaPlaza.Control.Vue.Notifications.SessionMessageType.Error) {
				return this.$snotify.error("…", config);
			}
			else if (this.from.Type === MiaPlaza.Control.Vue.Notifications.SessionMessageType.Warning) {
				return this.$snotify.warning("…", config);
			}
			else if (this.from.Type === MiaPlaza.Control.Vue.Notifications.SessionMessageType.Success) {
				return this.$snotify.success("…", config);
			}
			else {
				return this.$snotify.info("…", config);
			}
		};
	}

	protected getToastConfig(): SnotifyToastConfig {
		let timeout: number;
		switch (this.from.Type) {
			case MiaPlaza.Control.Vue.Notifications.SessionMessageType.Success:
			case MiaPlaza.Control.Vue.Notifications.SessionMessageType.Info:
				timeout = 5000;
				break;
			default:
				timeout = 0;
		}

		return {
			...this.getDefaultToastConfig(),
			buttons: [{ text: this.getPortalId("Close"), action: () => this.dismissOnServer().then(() => this.hide()) }],
			// See https://dev.miaplaza.com/miaplaza/website/issues/10811 for corresponding discussion
			timeout: this.from.Timeout ?? timeout,
		};
	}
}

export default toNative(SessionMessage);
</script>
